import { createContext, useContext } from "react"
import PropTypes from "prop-types"
import { MultiContext } from "~/contexts/MultiContext"

export const SingleContext = createContext()

export function SingleContextProvider({ position, uuid, videoData, children }) {
  const {
    focus,
    gridConfig,
    updateVideo: updateVideoByPositionAndUUID,
    removeVideo: removeVideoByPositionAndUUID,
    muteAllBut,
  } = useContext(MultiContext)

  const large = gridConfig.large.includes(position)
  const focused = position === focus

  const updateVideo = (newData) => updateVideoByPositionAndUUID(position, uuid, newData)

  const removeVideo = () => removeVideoByPositionAndUUID(position, uuid)

  const muteAllButMe = () => muteAllBut(uuid)

  return (
    <SingleContext.Provider
      value={{
        focused,
        large,
        position,
        uuid,
        videoData,
        updateVideo,
        removeVideo,
        muteAllButMe,
      }}
    >
      {children}
    </SingleContext.Provider>
  )
}
SingleContextProvider.propTypes = {
  position: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  videoData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    videoId: PropTypes.string.isRequired,
    player: PropTypes.object,
  }).isRequired,
  children: PropTypes.node.isRequired,
}
